export default "/shell-white-coin.f3decfaa267b24ea03bee86deba574a6.svg";